// Где мы работаем — вопросом из разметки.
//
// Слой различий (`./index`) отвечает обещанием: обёртка сообщает платформу командой, и первый
// ответ приходит следующим кадром. Разметке нужен признак прямо сейчас, поэтому здесь хук.
//
// Отдельным файлом, а не в самом слое: слой не знает про React и не должен — его гоняют
// обычными тестами без окружения браузера.

import { useEffect, useState } from 'react';

import { платформа, type Платформа } from './index';

/**
 * Где работаем. `null` — ответ ещё не пришёл, это состояние первого кадра.
 *
 * Разбирать `null` отдельно обязательно: «пока не знаю» это не «браузер». Ветка, написанная
 * как `где !== 'ipad'`, на первом кадре покажет планшету десктопное — и человек увидит, как
 * элемент появляется и пропадает.
 */
export function useПлатформа(): Платформа | null {
  const [где, setГде] = useState<Платформа | null>(null);

  useEffect(() => {
    let живо = true;
    void платформа().then((ответ) => {
      if (живо) {
        setГде(ответ);
      }
    });
    return () => {
      живо = false;
    };
  }, []);

  return где;
}
